import { updateState } from '@angular-architects/ngrx-toolkit';
import { signalStore, withComputed, withMethods, withState } from '@ngrx/signals';

import { withDebugDevTools } from '../../../debug/devtools.features';

export type BaseScrollOptions = {
    behaviour: 'smooth' | 'auto';
};
type DispatchScrollOptions = BaseScrollOptions;
type ScrollOptions = BaseScrollOptions & {
    hasScrolled: boolean;
};

type ChatUIState = {
    overflowEnabled: boolean;
    scrollOptions: ScrollOptions | DispatchScrollOptions;
};

const initialState: ChatUIState = {
    overflowEnabled: true,
    scrollOptions: {
        behaviour: 'auto',
        hasScrolled: false
    }
};

export type ChatUIStore = InstanceType<typeof ChatUIStore>;

export const ChatUIStore = signalStore(
    { providedIn: 'root' },
    withState(initialState),
    withDebugDevTools('chat-ui-store'),
    withComputed((store) => ({
        initialScroll: () => (store.scrollOptions() as ScrollOptions).hasScrolled === false
    })),
    withMethods((store) => ({
        dispatchScrollAction(scrollOptions: DispatchScrollOptions): void {
            if (store.initialScroll() === true) {
                updateState(store, 'Dispatching scroll', { scrollOptions: { ...scrollOptions, hasScrolled: true } });
                return;
            }
            updateState(store, 'Dispatching scroll', { scrollOptions: { ...scrollOptions } });
        },

        setOverflowEnabled(overflowEnabled: boolean): void {
            updateState(store, `Setting overflow ${overflowEnabled}`, { overflowEnabled });
        }
    }))
);
